import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

const AboutPage = () => {
  const values = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Mission',
      description: 'Offrir des services de bien-être de qualité supérieure pour améliorer la santé mentale, émotionnelle et physique de nos patients à Lubumbashi et dans toute la RDC.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Vision',
      description: 'Devenir la référence en matière de bien-être et de vitalité en République Démocratique du Congo, en combinant expertise médicale et technologies innovantes.'
    },
    {
      icon: 'ri-star-line',
      title: 'Valeurs',
      description: 'Excellence professionnelle, approche humaine, confidentialité, innovation technologique et engagement envers le bien-être durable de chaque patient.'
    }
  ];

  const team = [
    {
      name: 'Dr. Sarah Mukendi',
      role: 'Directrice & Psychologue clinicienne',
      image: 'https://public.readdy.ai/ai/img_res/5d491e6c5a7e11fa15cc922ccbecf7b2.jpg'
    },
    {
      name: 'Marie Kabila',
      role: 'Massothérapeute certifiée',
      image: 'https://readdy.ai/api/search-image?query=professional%20african%20female%20massage%20therapist%20in%20wellness%20uniform%2C%20caring%20healthcare%20worker%2C%20spa%20clinic%20environment%2C%20therapeutic%20expertise%2C%20professional%20portrait&width=400&height=500&seq=team2&orientation=portrait'
    },
    {
      name: 'Dr. Jean Kalombo',
      role: 'Nutritionniste diplômé',
      image: 'https://readdy.ai/api/search-image?query=professional%20african%20male%20nutritionist%20in%20medical%20attire%2C%20healthcare%20nutrition%20expert%2C%20modern%20clinic%20setting%2C%20professional%20medical%20portrait&width=400&height=500&seq=team3&orientation=portrait'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <WhatsAppButton />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-b from-primary/5 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <div className="inline-flex items-center space-x-2 bg-white px-4 py-2 rounded-full shadow-md mb-6">
              <span className="text-sm font-medium text-primary">À Propos</span>
            </div>
            <h1 className="font-serif text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              HMC CLINIC
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Votre partenaire bien-être à Lubumbashi pour une vie plus saine et équilibrée
            </p>
          </motion.div>
        </div>
      </section>

      {/* Mission, Vision, Values */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-20">
          <div className="grid md:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center"
              >
                <div className="w-20 h-20 flex items-center justify-center bg-primary rounded-full mx-auto mb-6">
                  <i className={`${value.icon} text-4xl text-white`}></i>
                </div>
                <h3 className="font-serif text-2xl font-bold text-gray-900 mb-4">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-20">
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <img
                src="https://readdy.ai/api/search-image?query=modern%20wellness%20clinic%20interior%20with%20comfortable%20waiting%20area%2C%20professional%20medical%20facility%2C%20clean%20white%20design%20with%20blue%20accents%2C%20welcoming%20healthcare%20environment%2C%20natural%20lighting&width=700&height=500&seq=about1&orientation=landscape"
                alt="HMC CLINIC Interior"
                className="rounded-3xl shadow-2xl w-full h-[500px] object-cover object-top"
              />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="space-y-6"
            >
              <h2 className="font-serif text-4xl font-bold text-gray-900">
                Une clinique moderne au cœur de Lubumbashi
              </h2>
              <p className="text-gray-600 leading-relaxed">
                HMC CLINIC est née de la volonté de proposer des services de bien-être de qualité internationale à Lubumbashi. Nous croyons fermement que chaque personne mérite un accompagnement professionnel pour atteindre son plein potentiel de santé et de vitalité.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Notre équipe multidisciplinaire combine expertise médicale, approche humaine et technologies innovantes pour offrir des solutions personnalisées adaptées aux besoins spécifiques de chaque patient.
              </p>
              <div className="grid grid-cols-2 gap-6 pt-4">
                <div>
                  <div className="text-3xl font-bold text-primary mb-2">500+</div>
                  <div className="text-sm text-gray-600">Patients accompagnés</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-primary mb-2">5 ans</div>
                  <div className="text-sm text-gray-600">D'expérience</div>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="space-y-6 order-2 lg:order-1"
            >
              <h2 className="font-serif text-4xl font-bold text-gray-900">
                Une approche personnalisée et humaine
              </h2>
              <p className="text-gray-600 leading-relaxed">
                Chez HMC CLINIC, nous comprenons que chaque personne est unique. C'est pourquoi nous prenons le temps d'écouter vos besoins, vos préoccupations et vos objectifs de santé avant de proposer un plan de soins personnalisé.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Notre approche holistique prend en compte tous les aspects de votre bien-être : physique, mental et émotionnel. Nous vous accompagnons avec bienveillance et professionnalisme à chaque étape de votre parcours vers une meilleure santé.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-2xl text-primary flex-shrink-0"></i>
                  <span className="text-gray-700">Consultation initiale approfondie pour comprendre vos besoins</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-2xl text-primary flex-shrink-0"></i>
                  <span className="text-gray-700">Plans de soins personnalisés et adaptables</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-2xl text-primary flex-shrink-0"></i>
                  <span className="text-gray-700">Suivi régulier et ajustements selon vos progrès</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-2xl text-primary flex-shrink-0"></i>
                  <span className="text-gray-700">Confidentialité et respect absolu de votre vie privée</span>
                </li>
              </ul>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="order-1 lg:order-2"
            >
              <img
                src="https://readdy.ai/api/search-image?query=compassionate%20healthcare%20professional%20consulting%20with%20patient%2C%20personalized%20medical%20care%2C%20warm%20welcoming%20atmosphere%2C%20professional%20clinic%20consultation%20room%2C%20caring%20doctor-patient%20relationship&width=700&height=500&seq=about2&orientation=landscape"
                alt="Approche personnalisée"
                className="rounded-3xl shadow-2xl w-full h-[500px] object-cover object-top"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Notre équipe d'experts
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Des professionnels qualifiés et passionnés, dédiés à votre bien-être
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8">
            {team.map((member, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow"
              >
                <div className="h-80 overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="font-semibold text-xl text-gray-900 mb-2">{member.name}</h3>
                  <p className="text-primary font-medium">{member.role}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-primary to-primary-dark text-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-20 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-8"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold">
              Prêt à commencer votre parcours bien-être ?
            </h2>
            <p className="text-xl text-white/90">
              Prenez rendez-vous dès aujourd'hui et découvrez comment nous pouvons vous aider
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="https://wa.me/243850465500"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-3 bg-accent hover:bg-accent-dark text-white px-8 py-4 rounded-full font-semibold transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                <span>Prendre rendez-vous</span>
              </a>
              <Link
                to="/nos-services"
                className="inline-flex items-center space-x-3 bg-white hover:bg-gray-100 text-primary px-8 py-4 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap"
              >
                <span>Découvrir nos services</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;